/* SKINTIFIC Pakistan theme scripts. Plain custom elements; every feature degrades to a working link or form. */
(() => {
  const theme = window.theme || { routes: {}, strings: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const debounce = (fn, ms) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const sectionInner = (html) => {
    const doc = parseHTML(html);
    const el = doc.querySelector('.shopify-section');
    return el ? el.innerHTML : doc.body.innerHTML;
  };

  /* ── Scroll lock ──
     overflow:hidden on <body> doesn't stop touch scrolling on iPhone, so the page is pinned in place with
     position:fixed and put back exactly where it was when the last panel closes. */
  let lockCount = 0;
  let lockedY = 0;
  function lockScroll() {
    if (lockCount++ > 0) return;
    lockedY = window.scrollY;
    const gap = window.innerWidth - document.documentElement.clientWidth;
    Object.assign(document.body.style, { position: 'fixed', top: `-${lockedY}px`, left: '0', right: '0', paddingRight: gap ? `${gap}px` : '' });
    document.body.classList.add('has-drawer');
  }
  function unlockScroll() {
    if (lockCount === 0 || --lockCount > 0) return;
    Object.assign(document.body.style, { position: '', top: '', left: '', right: '', paddingRight: '' });
    document.body.classList.remove('has-drawer');
    window.scrollTo({ top: lockedY, behavior: 'instant' });
  }

  /* ── Drawers ── */
  let lastFocus = null;
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    $$('.drawer:not([hidden])').forEach((d) => d !== drawer && closeDrawer(d, false));
    lastFocus = document.activeElement;
    const wasOpen = !drawer.hidden;
    drawer.hidden = false;
    if (!wasOpen) lockScroll();
    const focusTarget = $('[data-predictive-input]', drawer) || $('[role="dialog"]', drawer);
    requestAnimationFrame(() => focusTarget && focusTarget.focus());
  }
  function closeDrawer(drawer, restoreFocus = true) {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    unlockScroll();
    if (restoreFocus && lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.dataset.openDrawer);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('.drawer'));
    const cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && theme.cartType === 'drawer' && document.getElementById('CartDrawer')) {
      e.preventDefault();
      openDrawer('CartDrawer');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = $$('.drawer:not([hidden])').pop();
    if (open) closeDrawer(open);
    $$('.mega__details[open]').forEach((d) => d.removeAttribute('open'));
    const filters = $('.listing__filters.is-open');
    if (filters) filters.classList.remove('is-open');
  });
  // Keep Tab inside an open drawer.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const drawer = $$('.drawer:not([hidden])').pop();
    if (!drawer) return;
    const focusable = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', drawer).filter((el) => el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
  for (const name of ['cart-drawer', 'search-drawer', 'menu-drawer']) {
    if (!customElements.get(name)) customElements.define(name, class extends HTMLElement {});
  }

  /* ── Cart ── */
  const cartSections = () => {
    const ids = ['cart-icon-bubble'];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    const page = $('#CartPage');
    if (page) {
      const section = page.closest('.shopify-section');
      if (section) ids.push(section.id.replace('shopify-section-', ''));
    }
    return ids;
  };
  function renderCartSections(sections) {
    if (!sections) return;
    for (const [id, html] of Object.entries(sections)) {
      if (!html) continue;
      if (id === 'cart-icon-bubble') {
        const bubble = $('#cart-icon-bubble');
        if (bubble) {
          $$('.cart-count, .visually-hidden', bubble).forEach((n) => n.remove());
          bubble.insertAdjacentHTML('beforeend', sectionInner(html));
        }
      } else if (id === 'cart-drawer') {
        const inner = $('#CartDrawerInner');
        if (inner) inner.innerHTML = sectionInner(html);
      } else {
        const section = document.getElementById(`shopify-section-${id}`);
        if (section) section.innerHTML = sectionInner(html);
      }
    }
  }
  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: cartSections(), sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.error);
    return data;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const button = $('[data-add-button]', form);
    const errorEl = $('[data-form-error]', form) || $('[data-form-error]', form.closest('.product__buy') || document.createElement('div'));
    if (button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
    }
    if (errorEl) errorEl.hidden = true;
    try {
      const formData = new FormData(form);
      // Quantity inputs live outside the form via the form="" attribute and are included by FormData.
      const body = { items: [{ id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) }] };
      const sellingPlan = formData.get('selling_plan');
      if (sellingPlan) body.items[0].selling_plan = Number(sellingPlan);
      const data = await cartRequest(`${theme.routes.cartAdd}.js`, body);
      if (theme.cartType === 'drawer' && document.getElementById('CartDrawer')) {
        renderCartSections(data.sections);
        openDrawer('CartDrawer');
      } else {
        window.location.href = theme.routes.cart;
      }
    } catch (err) {
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } else {
        alert(err.message);
      }
    } finally {
      if (button) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      }
    }
  });

  const changeLine = async (lineEl, quantity) => {
    lineEl.classList.add('is-updating');
    const container = lineEl.closest('#CartDrawer, #CartPage');
    const lineNumber = lineEl.dataset.line;
    try {
      const data = await cartRequest(`${theme.routes.cartChange}.js`, { line: Number(lineNumber), quantity });
      renderCartSections(data.sections);
      // Re-rendering replaces the focused control; put keyboard focus back on the same line, or on the cart itself.
      const scope = container && document.getElementById(container.id);
      const target = scope && ($(`[data-line="${lineNumber}"] [data-line-quantity]`, scope) || $('.drawer__panel', scope) || $('h1', scope));
      if (target) {
        if (!target.hasAttribute('tabindex') && !/^(INPUT|BUTTON|A)$/.test(target.tagName)) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    } catch (err) {
      lineEl.classList.remove('is-updating');
      alert(err.message);
    }
  };
  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-line-remove]');
    if (remove) changeLine(remove.closest('[data-line]'), 0);
  });
  document.addEventListener(
    'change',
    debounce((e) => {
      const input = e.target.closest('[data-line-quantity]');
      if (input) changeLine(input.closest('[data-line]'), Math.max(0, Number(input.value) || 0));
    }, 300),
  );

  /* ── Product card swatches: pick the variant the card adds, and show its price ── */
  document.addEventListener('change', (e) => {
    const input = e.target.closest('input[name="card-option"]');
    if (!input) return;
    const card = input.closest('[data-product-card]');
    const form = input.form;
    $('[data-card-variant]', form).value = input.value;
    const price = $('[data-card-price]', card);
    if (price && input.dataset.price) price.innerHTML = input.dataset.price;
    const buttonPrice = $('[data-card-button-price]', card);
    if (buttonPrice && input.dataset.amount) buttonPrice.textContent = input.dataset.amount;
    const image = $('.card__image:not(.card__image--secondary)', card);
    if (image && input.dataset.image) {
      image.removeAttribute('srcset');
      image.src = input.dataset.image;
    }
    const button = $('[data-add-button]', form);
    if (button) button.disabled = input.disabled;
  });

  /* ── Quantity stepper ── */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = $('input', this);
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn) return;
        const min = Number(this.input.min || 0);
        const max = this.input.max ? Number(this.input.max) : Infinity;
        const current = Number(this.input.value) || 0;
        const next = btn.name === 'plus' ? Math.min(max, current + 1) : Math.max(min, current - 1);
        if (next === current) return;
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }
  customElements.define('quantity-input', QuantityInput);

  /* ── Announcement bar ── */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.announcement__slide', this);
      if (this.slides.length < 2) return;
      this.index = 0;
      $('[data-ann-prev]', this)?.addEventListener('click', () => this.go(this.index - 1));
      $('[data-ann-next]', this)?.addEventListener('click', () => this.go(this.index + 1));
      const pause = (on) => {
        this.paused = on;
        this.classList.toggle('is-paused', on);
      };
      this.addEventListener('mouseenter', () => pause(true));
      this.addEventListener('mouseleave', () => pause(false));
      this.addEventListener('focusin', () => pause(true));
      this.addEventListener('focusout', () => (this.paused = false));
      if (!reducedMotion) setInterval(() => !this.paused && this.go(this.index + 1), Number(this.dataset.autoplay || 5) * 1000);
    }
    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, n) => (s.hidden = n !== this.index));
    }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  /* ── Header / mega menu ── */
  customElements.define('sticky-header', class extends HTMLElement {});
  class MegaMenu extends HTMLElement {
    connectedCallback() {
      this.details = $('details', this);
      const hoverable = window.matchMedia('(hover: hover)');
      this.details.addEventListener('toggle', () => {
        if (this.details.open) $$('.mega__details[open]').forEach((d) => d !== this.details && d.removeAttribute('open'));
      });
      // With a mouse the panel opens on hover, so a click on the top item goes to its page (as on the reference
      // site) instead of toggling the panel shut. Touch and keyboard users still toggle the panel.
      const summary = $('summary', this);
      summary?.addEventListener('click', (e) => {
        if (!hoverable.matches || e.detail === 0 || !summary.dataset.url || summary.dataset.url === '#') return;
        e.preventDefault();
        window.location.href = summary.dataset.url;
      });
      this.addEventListener('mouseenter', () => hoverable.matches && (this.details.open = true));
      this.addEventListener('mouseleave', () => hoverable.matches && (this.details.open = false));
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.details.open = false;
      });
    }
  }
  customElements.define('mega-menu', MegaMenu);
  document.addEventListener('click', (e) => {
    if (!e.target.closest('mega-menu')) $$('.mega__details[open]').forEach((d) => d.removeAttribute('open'));
  });

  /* ── Predictive search ── */
  const searchInput = $('[data-predictive-input]');
  const searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults && theme.routes.predictiveSearch) {
    let controller;
    const run = debounce(async () => {
      const q = searchInput.value.trim();
      if (q.length < 2) {
        searchResults.innerHTML = '';
        searchInput.setAttribute('aria-expanded', 'false');
        return;
      }
      controller?.abort();
      controller = new AbortController();
      try {
        const url = `${theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,query,page&resources[limit]=6&resources[options][prefix]=last`;
        const res = await fetch(url, { signal: controller.signal });
        searchResults.innerHTML = sectionInner(await res.text());
        searchInput.setAttribute('aria-expanded', 'true');
      } catch (err) {
        if (err.name !== 'AbortError') searchResults.innerHTML = '';
      }
    }, 250);
    searchInput.addEventListener('input', run);
  }

  /* ── Slideshow ── */
  class SlideShow extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.slideshow__slide', this);
      this.dots = $$('[data-slide-to]', this);
      this.index = 0;
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.slideTo), true)));
      const pause = (on) => {
        this.paused = on;
        this.classList.toggle('is-paused', on);
      };
      this.addEventListener('mouseenter', () => pause(true));
      this.addEventListener('mouseleave', () => pause(false));
      this.addEventListener('focusin', () => pause(true));
      let startX = null;
      let startY = 0;
      this.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        },
        { passive: true },
      );
      this.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        // Scrolling the page past the banner moves the finger mostly up or down: that must not change slides.
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true);
        startX = null;
      });
      if (this.dataset.autoplay === 'true' && !reducedMotion && this.slides.length > 1) {
        this.style.setProperty('--slide-speed', `${Number(this.dataset.speed || 6)}s`);
        this.classList.add('is-autoplay');
        this.timer = setInterval(() => !this.paused && !document.hidden && this.go(this.index + 1), Number(this.dataset.speed || 6) * 1000);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    go(i, user) {
      if (user) {
        this.paused = true;
        this.classList.add('is-paused');
      }
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, n) => s.classList.toggle('is-active', n === this.index));
      this.dots.forEach((d, n) => {
        d.classList.toggle('is-active', n === this.index);
        if (n === this.index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }
  }
  customElements.define('slide-show', SlideShow);

  /* ── Tabs ── */
  class TabGroup extends HTMLElement {
    connectedCallback() {
      this.tabs = $$('[role="tab"]', this);
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          const forward = e.key === 'ArrowRight' || e.key === 'ArrowDown';
          const back = e.key === 'ArrowLeft' || e.key === 'ArrowUp';
          if (forward || back) {
            e.preventDefault();
            const next = (i + (forward ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          }
        });
      });
    }
    select(i) {
      this.tabs.forEach((tab, n) => {
        const selected = n === i;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
    }
  }
  customElements.define('tab-group', TabGroup);
  // Routine steps on the product page are vertical tabs.
  customElements.define('routine-steps', class extends TabGroup {});

  /* ── Product rails ── */
  class ProductRail extends HTMLElement {
    connectedCallback() {
      this.track = $('.rail__track', this);
      this.prev = $('[data-rail-prev]', this);
      this.next = $('[data-rail-next]', this);
      if (!this.track) return;
      const step = () => this.track.clientWidth * 0.9;
      this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.next?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      const update = () => {
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      this.track.addEventListener('scroll', debounce(update, 50), { passive: true });
      new ResizeObserver(update).observe(this.track);
    }
  }
  customElements.define('product-rail', ProductRail);

  /* ── Product gallery ── */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.main = $('[data-gallery-main]', this);
      this.thumbs = $$('[data-thumb]', this);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.show(t.dataset.thumb)));
      if (this.main && this.thumbs.length) {
        this.main.addEventListener(
          'scroll',
          debounce(() => {
            const i = Math.round(this.main.scrollLeft / this.main.clientWidth);
            this.setActive(this.thumbs[i]?.dataset.thumb);
          }, 80),
          { passive: true },
        );
      }
    }
    show(mediaId) {
      const slide = $(`[data-media-id="${mediaId}"]`, this);
      if (!slide) return;
      this.main.scrollTo({ left: slide.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
      this.setActive(mediaId);
    }
    setActive(mediaId) {
      this.thumbs.forEach((t) => {
        const active = t.dataset.thumb === String(mediaId);
        t.classList.toggle('is-active', active);
        if (active) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }
  }
  customElements.define('media-gallery', MediaGallery);

  // "See it in action" thumbnails outside the gallery: show that image in the section's gallery.
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-show-media]');
    if (!button) return;
    const gallery = $('media-gallery', button.closest('.shopify-section') || document);
    if (!gallery) return;
    gallery.show(button.dataset.showMedia);
    if (gallery.getBoundingClientRect().top < 0) gallery.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ── Variant picker ── */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse($('[data-variants]', this).textContent);
      this.root = this.closest('product-info');
      this.addEventListener('change', () => this.onChange());
    }
    selectedOptions() {
      return $$('fieldset', this).map((fs) => $('input:checked', fs)?.value);
    }
    async onChange() {
      const options = this.selectedOptions();
      $$('fieldset', this).forEach((fs, i) => {
        const label = $('[data-selected-value]', fs);
        if (label) label.textContent = options[i];
      });
      const variant = this.variants.find((v) => v.options.every((o, i) => o === options[i]));
      const idInput = $('[data-variant-id]', this.root);
      const button = $('[data-add-button]', this.root);
      if (!variant) {
        if (button) {
          button.disabled = true;
          button.textContent = theme.strings.unavailable;
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media) $('media-gallery', this.root)?.show(variant.featured_media.id);
      try {
        const res = await fetch(`${this.root.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`);
        const doc = parseHTML(await res.text());
        $$('[data-variant-replace]', this.root).forEach((el) => {
          const fresh = doc.querySelector(`[data-variant-replace="${el.dataset.variantReplace}"]`);
          if (!fresh) return;
          if (el.dataset.variantReplace === 'buy') {
            // Keep the shopper's quantity; only swap the hidden id and the button.
            const freshButton = $('[data-add-button]', fresh);
            if (button && freshButton) {
              button.disabled = freshButton.disabled;
              button.textContent = freshButton.textContent;
            }
          } else {
            el.innerHTML = fresh.innerHTML;
          }
        });
      } catch {
        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        }
      }
    }
  }
  customElements.define('variant-picker', VariantPicker);
  customElements.define('product-info', class extends HTMLElement {});

  /* ── Sticky add to cart ── */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const button = $('[data-sticky-target]', this);
      const form = button && document.getElementById(button.dataset.stickyTarget);
      if (!form) return;
      new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        document.body.classList.toggle('has-sticky-atc', !this.hidden);
      }).observe(form);
      button.addEventListener('click', () => {
        form.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        $('[data-add-button]', form)?.focus({ preventScroll: true });
      });
    }
  }
  customElements.define('sticky-atc', StickyAtc);

  /* ── Recommendations (lazy) ── */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver(
        async ([entry], observer) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          try {
            const res = await fetch(this.dataset.url);
            const doc = parseHTML(await res.text());
            const fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
          } catch {
            /* recommendations are optional */
          }
        },
        { rootMargin: '0px 0px 400px 0px' },
      ).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ── Collection filters ── */
  customElements.define('facet-drawer', class extends HTMLElement {});
  const facetsForm = $('[data-facets-form]');
  if (facetsForm) {
    const submit = () => {
      const params = new URLSearchParams(new FormData(facetsForm));
      for (const [key, value] of Array.from(params.entries())) if (value === '') params.delete(key);
      window.location.search = params.toString();
    };
    facetsForm.addEventListener('change', (e) => {
      if (e.target.type === 'number') return;
      submit();
    });
    facetsForm.addEventListener('input', debounce((e) => e.target.type === 'number' && submit(), 800));
    facetsForm.addEventListener('submit', (e) => {
      e.preventDefault();
      submit();
    });
  }
  $$('[data-sort-select]').forEach((select) =>
    select.addEventListener('change', () => {
      const form = document.getElementById(select.getAttribute('form'));
      const hidden = form && $('[data-sort-input]', form);
      if (hidden) {
        hidden.value = select.value;
        form.requestSubmit();
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      }
    }),
  );
  document.addEventListener('click', (e) => {
    const filters = $('.listing__filters');
    if (!filters) return;
    if (e.target.closest('[data-facet-open]')) {
      if (!filters.classList.contains('is-open')) lockScroll();
      filters.classList.add('is-open');
      $('.facet-drawer__close', filters)?.focus();
    } else if (e.target.closest('[data-facet-close]') || e.target === filters) {
      if (filters.classList.contains('is-open')) unlockScroll();
      filters.classList.remove('is-open');
    }
  });

  /* ── Read more ── */
  class ReadMore extends HTMLElement {
    connectedCallback() {
      const content = $('[data-read-more]', this);
      const toggle = $('[data-read-more-toggle]', this);
      if (!content || !toggle) return;
      content.classList.add('is-clamped');
      if (content.scrollHeight <= content.clientHeight + 2) {
        content.classList.remove('is-clamped');
        return;
      }
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const clamped = content.classList.toggle('is-clamped');
        toggle.textContent = clamped ? toggle.dataset.more : toggle.dataset.less;
      });
    }
  }
  customElements.define('read-more', ReadMore);

  /* ── Localization (country / currency) ── */
  $$('[data-localization-select]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

  /* ── Address forms: provinces for the selected country ── */
  $$('[data-country-select]').forEach((select) => {
    const province = document.getElementById(select.dataset.provinceTarget);
    const wrapper = province?.closest('[data-province-wrapper]');
    const fill = () => {
      const option = select.options[select.selectedIndex];
      const provinces = option ? JSON.parse(option.dataset.provinces || '[]') : [];
      if (!province) return;
      province.innerHTML = provinces.map(([value, label]) => `<option value="${value}">${label}</option>`).join('');
      if (wrapper) wrapper.hidden = provinces.length === 0;
      if (province.dataset.default) province.value = province.dataset.default;
    };
    if (select.dataset.default) select.value = select.dataset.default;
    select.addEventListener('change', fill);
    fill();
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-confirm]');
    if (form && !window.confirm(form.dataset.confirm)) e.preventDefault();
  });

  /* ── Scroll reveal ──
     Fades content up as it scrolls into view, staggering siblings (cards in a row, tiles…). Purely decorative:
     skipped for reduced motion and in the theme editor, and nothing is hidden until this script has run. */
  const REVEAL = [
    '.section__header', '.section__title', '.image-cards__heading',
    '.card', '.tiles__item', '.image-card', '.shoppable__item', '.brand-card',
    '.feature-split__media', '.feature-split__products > *',
    '.image-text__media', '.image-text__content', '.newsletter__media', '.newsletter__text',
    '.product-spotlight__media > li', '.product-spotlight__info', '.testimonials', '.story-images__image',
    '.product-details__grid', '.routine__grid', '.routine-set', '.compare__scroll', '.collection-hero', '.article-card',
  ].join(',');
  function initReveal(root = document) {
    if (reducedMotion || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          el.classList.add('is-revealed');
          observer.unobserve(el);
          el.addEventListener('transitionend', () => el.classList.add('is-settled'), { once: true });
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
    );
    const sidewaysScroller = (el) => {
      for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
        if (p.classList.contains('marquee') || /(auto|scroll)/.test(getComputedStyle(p).overflowX)) return p;
      }
      return null;
    };
    $$(REVEAL, root).forEach((el) => {
      if (el.closest('.drawer, .mega, header, [aria-hidden="true"]') || el.parentElement?.closest('[data-reveal]')) return;
      // Cards off to the side of a swipe row would only fade in mid-swipe; fade the whole row in once instead.
      const scroller = sidewaysScroller(el);
      if (scroller) {
        if (!scroller.hasAttribute('data-reveal') && !scroller.parentElement?.closest('[data-reveal]')) {
          scroller.setAttribute('data-reveal', '');
          observer.observe(scroller);
        }
        return;
      }
      const siblings = Array.from(el.parentElement?.children || []).filter((c) => c.matches(REVEAL));
      const i = Math.max(0, siblings.indexOf(el));
      el.setAttribute('data-reveal', '');
      el.style.setProperty('--reveal-delay', `${Math.min(i, 6) * 80}ms`);
      observer.observe(el);
    });
  }
  document.documentElement.classList.add('js-reveal');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initReveal());
  else initReveal();

  /* ── Showcase cards: tilt the photo toward the pointer, with a soft highlight where it points ── */
  if (!reducedMotion && window.matchMedia('(hover: hover)').matches) {
    let tiltFrame = 0;
    let tiltEvent = null;
    document.addEventListener(
      'pointermove',
      (e) => {
        tiltEvent = e;
        if (tiltFrame) return;
        tiltFrame = requestAnimationFrame(() => {
          tiltFrame = 0;
          const ev = tiltEvent;
          const media = ev.target.closest?.('[data-tilt-cards] .card__media');
          if (!media || document.documentElement.classList.contains('is-scrolling')) return;
          const r = media.getBoundingClientRect();
          const x = (ev.clientX - r.left) / r.width;
          const y = (ev.clientY - r.top) / r.height;
          media.style.setProperty('--tilt-y', `${((x - 0.5) * 10).toFixed(2)}deg`);
          media.style.setProperty('--tilt-x', `${((0.5 - y) * 10).toFixed(2)}deg`);
          media.style.setProperty('--glow-x', `${(x * 100).toFixed(1)}%`);
          media.style.setProperty('--glow-y', `${(y * 100).toFixed(1)}%`);
        });
      },
      { passive: true },
    );
    document.addEventListener('pointerout', (e) => {
      const media = e.target.closest?.('[data-tilt-cards] .card__media');
      if (!media || media.contains(e.relatedTarget)) return;
      media.style.removeProperty('--tilt-x');
      media.style.removeProperty('--tilt-y');
    });
  }

  /* ── Scroll performance helpers ── */
  // Flag the page while it scrolls so hover effects don't fire on cards passing under the pointer.
  let scrollTimer = 0;
  // Touch screens have no hover, and blocking taps there would swallow the tap that follows a flick.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) window.addEventListener(
    'scroll',
    () => {
      if (!scrollTimer) document.documentElement.classList.add('is-scrolling');
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        scrollTimer = 0;
        document.documentElement.classList.remove('is-scrolling');
      }, 140);
    },
    { passive: true },
  );
  // Pause looping animations (marquees, ticker, hero) while they are off screen.
  if ('IntersectionObserver' in window) {
    const motion = new IntersectionObserver((entries) => entries.forEach((e) => e.target.classList.toggle('is-offscreen', !e.isIntersecting)), { rootMargin: '100px 0px' });
    const watchMotion = () => $$('.marquee, .na-ticker, .na-hero').forEach((el) => motion.observe(el));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchMotion);
    else watchMotion();
  }
})();
